import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePageTitleStore = defineStore('pageTitle', () => {
  const override = ref<string | null>(null)

  const setTitle = (title: string | null) => {
    override.value = title
  }

  return {
    override,
    setTitle,
  }
})
